import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store/types';
import LoadingSpinner from 'app/common/components/Spinner/LoadingSpinner';

const AsyncSpinner: React.FC = () => {
  const spinnerState = useSelector((state: RootState) => state.UI.spinners);
  const asyncSpinner = spinnerState.asyncSpinner;
  return (
    <>
      <LoadingSpinner visible={asyncSpinner.visible} />
      {/* <PaymentSpinner visible={paymentSpinner.visible} /> */}
    </>
  );
};

export default AsyncSpinner;
